import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";

/**
 * Round 2 cleanup:
 *  - Removed duplicate <AuthProvider> wrap (was in both index.js AND App.js,
 *    creating two separate auth contexts). AuthProvider now lives inside
 *    App.js alongside ErrorBoundary + ToastProvider.
 *  - Wrapped the root in <React.StrictMode> to surface unsafe lifecycle
 *    issues earlier during development.
 */

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Start measuring performance by passing a function (e.g. reportWebVitals(console.log))
reportWebVitals();
